export default __webpack_public_path__ + "static/media/(33).1b9c67e2.JPG";